import {useEffect} from "react";
import {useLocation} from "react-router-dom";

// When the URL has a hash (e.g. /portfolio#contact), wait for the route to
// render then smooth-scroll to the matching element. Retries a few times to
// handle slow-rendering sections (lazy components, animations, etc.).
const ScrollToHash = () => {
  const {pathname, hash} = useLocation();

  useEffect(() => {
    if (!hash) {
      // Plain route change — go to top.
      window.scrollTo({top: 0, behavior: "instant"});
      return;
    }

    const id = decodeURIComponent(hash.replace("#", ""));
    let attempts = 0;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({behavior: "smooth", block: "start"});
        return;
      }
      attempts += 1;
      if (attempts < 20) setTimeout(tryScroll, 80);
    };
    // Defer one tick so the route's components mount first.
    const t = setTimeout(tryScroll, 0);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
};

export default ScrollToHash;
